import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-header mb-0" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-link me-1" }),
    /*#__PURE__*/_createTextVNode(" Link da videochamada ")
  ])
], -1)
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph" }, " Se você precisar convidar alguém de fora do Psiapp para a sua sessão, basta compartilhar o link abaixo ", -1)
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = {
  key: 0,
  class: "btn btn-outline-success",
  disabled: ""
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-check-circle" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fa-regular fa-copy" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", {
          class: "text-subtitle me-3 mb-0 cursor-pointer",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleCallLink && _ctx.handleCallLink(...args)))
        }, _toDisplayString(_ctx.callLink), 1),
        (_ctx.copied)
          ? (_openBlock(), _createElementBlock("button", _hoisted_6, _hoisted_8))
          : (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "btn btn-custom",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleCopyCallLink && _ctx.handleCopyCallLink(...args)))
            }, _hoisted_10))
      ])
    ])
  ]))
}